{
  "type": "object",
  "name": "voucher",
  "class": "py-4",
  "virtual": {
    "itemHeight": 132,
    "display": 0
  },
  "definitions": [
    {
      "type": "group",
      "control": "div",
      "title": "Belegdaten",
      "definitions": [
        {
          "type": "group",
          "control": "div",
          "class": "flex flex-row w-full",
          "definitions": [
            {
              "type": "date",
              "title": "Fremdbelegdatum",
              "name": "belegdatum",
              "class": "",
              "titleClass": "hidden",
              "filter": true,
              "sortable": true
            },
            {
              "type": "text",
              "title": "",
              "text": "Neu",
              "class": "bg-secondary text-secondary-contrast rounded-full px-2 ml-2",
              "visible": {
                "name": "property",
                "property": "neuerBeleg",
                "rule": {
                  "name": "boolean",
                  "value": true
                }
              }
            }
          ]
        },
        {
          "type": "entity",
          "title": "",
          "name": "rechnungslieferant",
          "endpoint": "",
          "format": "{{number}} - {{name}}",
          "class": "font-bold"
        },
        {
          "type": "string",
          "title": "FremdbelegNr.: ",
          "name": "bezugsnummer",
          "class": "whitespace-nowrap"
        },
        {
          "type": "group",
          "control": "div",
          "class": "flex flex-row whitespace-nowrap",
          "definitions": [
            {
              "type": "text",
              "title": "",
              "text": "Baustelle: ",
              "class": "whitespace-pre"
            },
            {
              "type": "string",
              "title": "",
              "name": "lieferadresse.number",
              "titleClass": "hidden",
              "class": ""
            },
            {
              "type": "group",
              "control": "div",
              "class": "flex flex-row",
              "visible": {
                "name": "property",
                "property": "lieferadresse.subnumber",
                "rule": {
                  "name": "required"
                }
              },
              "definitions": [
                {
                  "type": "text",
                  "title": "",
                  "text": ","
                },
                {
                  "type": "string",
                  "title": "",
                  "name": "lieferadresse.subnumber",
                  "titleClass": "hidden",
                  "class": ""
                }
              ]
            },
            {
              "type": "group",
              "control": "div",
              "class": "flex flex-row",
              "visible": {
                "name": "property",
                "property": "lieferadresse.name",
                "rule": {
                  "name": "required"
                }
              },
              "definitions": [
                {
                  "type": "text",
                  "title": "",
                  "text": " - ",
                  "class": "whitespace-pre"
                },
                {
                  "type": "string",
                  "title": "",
                  "name": "lieferadresse.name",
                  "titleClass": "hidden",
                  "class": ""
                }
              ]
            }
          ],
          "visible": {
            "name": "property",
            "property": "lieferadresse",
            "rule": {
              "name": "required"
            }
          }
        },
        {
          "type": "group",
          "control": "div",
          "title": "",
          "class": "flex flex-row gap-1",
          "definitions": [
            {
              "type": "text",
              "title": "",
              "text": "Verknüpft",
              "class": "bg-secondary text-secondary-contrast rounded-full px-2 whitespace-nowrap",
              "visible": {
                "name": "property",
                "property": "erwstatus",
                "rule": {
                  "name": "equal",
                  "value": "E"
                }
              }
            },
            {
              "type": "text",
              "title": "",
              "text": "Freigegeben",
              "class": "bg-secondary text-secondary-contrast rounded-full px-2 whitespace-nowrap",
              "visible": {
                "name": "property",
                "property": "fakturenfreigabe",
                "rule": {
                  "name": "equal",
                  "value": "J"
                }
              }
            }
          ]
        }
      ]
    }
  ]
}
